//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'derOrderlist_';

const initialState = {  
	  data:[],
	  dataLoading: true,
	  dataFetchProps: {order:[['id','desc']],distinct:true,include:[
						{model:'der_client',as:'m_derOrderclient',attributes:['cust_name']},
			  {model:'der_order_file',as:'m_derOrderFile',attributes:['id','local_url','status','attachment_type','bank_url']},
			  {model:'der_pay',as:'m_derOrderpay',attributes:['id','project_id','settle_flag','partner_order_no','order_no','loan_status','repay_mode','pay_type','loan_rate','pay_time','loan_no','total_pay_amount','amount','interest','repay_date','remain_loan_amount','loan_date','loan_end_date']},
		  ]},
      modalVisible: false,
	  modalType: 'create',
	  orderDetailVisible: false,
	orderPayDetailVisible: false,
	  orderRepayDetailVisible: false,
	  pwdModalVisible: false,
	  selectedRow: {},  
	  clickRow:{},
	  selectedRowIndex: -1,  
	  selectedRows: [],  
      selectedRowKeys: [],	  
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,		 
		},
	   searchProps:{},
	  
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {		
	
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {
		
		let newData = state.data
		
		let {selectedRowIndex, id} = action.payload		
		
		newData[selectedRowIndex] = action.payload.data		
		
		return {...state, selectedRow: action.payload.data, data: newData}
	}
	


	case namespace+"deleteDataById": {
		
		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)
		
		return {...state, data: newData}
	}
	
	case namespace+"addOneRowData": {
		
		return {...state, data: [action.payload.data, ...state.data]}
	}
	
    default:
      return state;
  }
}